import styled from 'styled-components';

import React from 'react'

import  closeIcon  from '../images/icon/closeIcon.png'



const ButtonIcon = styled.img`
    cursor:'pointer';
    position: absolute;
    width: 2rem;
    height: auto;
    border: none;
    z-index:500;
    &:hover {
        transform: scale(1.1, 1.1);
    }
`

const CloseButton =({handler, style})=>{
    return(
        <ButtonIcon 
            src={closeIcon} 
            style={style}
            onClick={handler}/>
    )
}

const ResizeButton = ({handler, style, src})=>{
    return(
        <ButtonIcon
            src={src} 
            style={style}
            onClick={handler}
        />
    )
}

export {CloseButton, ResizeButton};